// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view-startup-lander .hero .hero-content{max-width:none}.view-startup-lander .hero .hero-pattern .man{left:0;max-width:361px}@media (max-width:991.98px){.view-startup-lander__benefits h3{font-size:1.625rem!important}}@media (max-width:991.98px){.view-startup-lander__benefits .card-benefit__description,.view-startup-lander__benefits .card-benefit__title{max-width:100%!important}}", ""]);
// Exports
module.exports = exports;
